<header class="page-header">
  <div class="page-header__inner">
    <h1 class="sr-only">Best Egg</h1>
    <div class="be-logo-v2-container">
      <app-be-logo-v2 [isLink]="true" url="/customer-hub"></app-be-logo-v2>
    </div>
    <nav
      class="primary-nav-container"
      aria-label="primary desktop site navigation"
      >
      <ul class="primary-nav">
        @for (navItem of navItems; track navItem) {
          <li class="primary-nav__item">
            <a
              (click)="onNavClick(navItem)"
              class="primary-nav__link"
              [ngClass]="navItem.isActive ? 'primary-nav__link--active' : ''"
              >
              <span>{{ navItem.title }}</span>
              @if (navItem.type === 'offers' && navItem.offerCount !== 0) {
                <span
                  class="count-bubble count-bubble__desktop"
                  >{{ navItem.offerCount }}</span
                  >
                }
                @if (navItem?.isExternalLink && !navItem?.subItems?.length) {
                  <span
                    class="external-link"
                    >
                    <app-icon-external-link></app-icon-external-link>
                  </span>
                }
              </a>
            </li>
          }
        </ul>
      </nav>
      <div class="right-group">
        <a
          class="btn-nude btn-username"
          [ngClass]="(isProfileActive$ | async) ? 'btn-username--active' : ''"
          routerLink="/customer-hub/profile"
          >
          <app-icon-user [color]="(isProfileActive$ | async) ? '#B8FF8D' : '#E8EEF2'"></app-icon-user>
          <span
            class="username-text status-dot"
          [ngClass]="{
            'status-dot--action-required-top-right': isRequiredActionDot,
            'status-dot--action-required-top-right-no-name':
              !viewModel?.customerFirstName
          }"
            >{{ viewModel?.customerFirstName | titlecase }}</span
            >
          </a>
          <button (click)="logOut()" class="befh-btn befh-btn--outline">
            Log out
          </button>
          <button
            class="btn-nude hamburger-toggle status-dot"
        [ngClass]="
          isRequiredActionDot ? 'status-dot--action-required-top-right' : ''
        "
            (click)="toggleNav()"
            >
            <app-icon-hamburger></app-icon-hamburger>
          </button>
        </div>
      </div>
      <div
        class="primary-nav__sub-menu"
    [ngClass]="
      desktopDropdownItems?.length ? 'primary-nav__sub-menu--is-expanded' : ''
    "
        [style.height]="subMenuDesktopHeight"
        >
        @if (desktopDropdownItems?.length) {
          <ul class="submenu-dropdown">
            @for (desktopDropdownItem of desktopDropdownItems; track desktopDropdownItem) {
              <li
                class="primary-nav__item"
                >
                <a (click)="onNavClick(desktopDropdownItem)" class="primary-nav__link">
                  <span>{{ desktopDropdownItem.title }}</span>
                  @if (desktopDropdownItem?.isExternalLink) {
                    <span
                      class="external-link"
                      >
                      <app-icon-external-link></app-icon-external-link>
                    </span>
                  }
                </a>
              </li>
            }
          </ul>
        }
      </div>
      <div
        class="error-drawer"
        [ngClass]="isErrorDrawerExpanded ? 'error-drawer--is-expanded' : ''"
        aria-live="polite"
        >
        <p class="error-drawer__text" [innerHTML]="navError?.markup"></p>
      </div>
    </header>

    <div
      class="nav-slide"
      [ngClass]="isNavExpanded ? 'nav-slide--is-expanded' : ''"
      >
      <div class="nav-slide__alpha" (click)="closeNavSlide(false)"></div>
      <div class="nav-slide__main">
        <button class="btn-nude nav-slide__close-btn" (click)="closeNavSlide(false)">
          <div class="nav-slide__header">
            <app-icon-close width="16" height="16" color="#9FA9B3"></app-icon-close>
          </div>
        </button>

        <!-- User / Offers Header Section -->
        <div class="nav-slide__user-section">
          <a
            class="nav-slide__user-btn status-dot"
        [ngClass]="{
          'nav-slide__user-btn--active': (isProfileActive$ | async),
          'status-dot--action-required-center-left': isRequiredActionDot
        }"
            routerLink="/customer-hub/profile"
            (click)="closeNavSlide(true)"
            >
            <app-icon-user [color]="(isProfileActive$ | async) ? '#B8FF8D' : '#E8EEF2'" width="20" height="20"></app-icon-user>
            <span class="nav-slide__user-name">
              {{viewModel?.customerFirstName | titlecase}} {{ viewModel?.customerLastName | titlecase }}
            </span>
          </a>

          <a
            class="nav-slide__offers-section"
            [ngClass]="(isOffersActive$ | async) ? 'nav-slide__offers-section--active' : ''"
            (click)="onOffersClick()"
            >
            <app-icon-offer-bag
              width="20"
              height="20"
              [color]="(isOffersActive$ | async) ? '#B8FF8D' : '#E8EEF2'"
            ></app-icon-offer-bag>
            <span class="nav-slide__offers-text">Offers for you</span>
            @if (getOffersCount() > 0) {
              <span
                class="nav-slide__offers-count"
                >
                {{ getOffersCount() }}
              </span>
            }
          </a>
        </div>

        <!-- Main Navigation -->
        <nav
          class="nav-slide__nav-container"
          aria-label="primary mobile site navigation"
          >
          <ul class="nav-slide__nav">
            @for (navItem of navItems | filterOffers; track navItem) {
              <li class="nav-slide__item">
                @if (!navItem?.subItems?.length) {
                  <a
                    (click)="onNavClick(navItem)"
                    class="nav-slide__link"
                    [ngClass]="navItem.isActive ? 'nav-slide__link--active' : ''"
                    >
                    <span class="nav-slide__link-icon">
                      @if (navItem.type === 'home') {
                        <app-icon-home
                          [color]="navItem.isActive ? '#B8FF8D' : '#E8EEF2'"
                          [outline]="!navItem.isActive"
                          width="20"
                          height="20"
                        ></app-icon-home>
                      }
                      @if (navItem.type === 'loan') {
                        <app-icon-dollar-circle
                          [color]="navItem.isActive ? '#B8FF8D' : '#E8EEF2'"
                          width="20"
                          height="20"
                        ></app-icon-dollar-circle>
                      }
                      @if (navItem.type === 'card') {
                        <app-icon-credit-card
                          [color]="navItem.isActive ? '#B8FF8D' : '#E8EEF2'"
                          width="20"
                          height="20"
                        ></app-icon-credit-card>
                      }
                      @if (navItem.type === 'befh') {
                        <app-icon-credit-gauge
                          [color]="navItem.isActive ? '#B8FF8D' : '#E8EEF2'"
                          width="20"
                          height="20"
                        ></app-icon-credit-gauge>
                      }
                    </span>
                    <span class="nav-slide__link-text">{{ navItem.title }}</span>
                    @if (navItem?.isExternalLink) {
                      <span
                        class="nav-slide__link-external"
                        >
                        <app-icon-external-link></app-icon-external-link>
                      </span>
                    }
                  </a>
                }
                @if (navItem?.subItems?.length) {
                  <a
                    (click)="onNavClick(navItem)"
                    class="nav-slide__link"
                    [attr.aria-expanded]="navItem.isSubMenuExpanded"
                    >
                    <span class="nav-slide__link-icon">
                      @if (navItem.type === 'loan') {
                        <app-icon-dollar-circle
                          [color]="navItem.isActive ? '#B8FF8D' : '#E8EEF2'"
                          width="20"
                          height="20"
                        ></app-icon-dollar-circle>
                      }
                      @if (navItem.type === 'card') {
                        <app-icon-credit-card
                          [color]="navItem.isActive ? '#B8FF8D' : '#E8EEF2'"
                          width="20"
                          height="20"
                        ></app-icon-credit-card>
                      }
                    </span>
                    <span class="nav-slide__link-text">{{ navItem.title }}</span>
                    <span class="nav-slide__link-chevron">
                      <app-icon-caret-v2 color='#E8EEF2' [direction]="navItem.isSubMenuExpanded ? 'up' : 'down'"></app-icon-caret-v2>
                    </span>
                  </a>
                }
                <div
                  class="error-drawer"
            [ngClass]="
              navItem?.isErrorExpanded ? 'error-drawer--is-expanded' : ''
            "
                  aria-live="polite"
                  >
                  <p class="error-drawer__text" [innerHTML]="navError?.markup"></p>
                </div>
                @if (navItem?.subItems?.length) {
                  <ul
                    class="nav-slide__sub-menu"
            [ngClass]="
              navItem.isSubMenuExpanded
                ? 'nav-slide__sub-menu--is-expanded'
                : ''
            "
                    [style.height]="navItem.subItemsMobileHeight"
                    >
                    @for (navItem of navItem.subItems; track navItem) {
                      <li
                        class="nav-slide__item"
                        >
                        <a
                          (click)="onNavClick(navItem)"
                          class="nav-slide__link nav-slide__link--sm"
                          >
                          <span>{{ navItem.title }}</span>
                          @if (navItem?.isExternalLink) {
                            <span
                              class="nav-slide__link-external"
                              >
                              <app-icon-external-link></app-icon-external-link>
                            </span>
                          }
                        </a>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        </nav>

        <!-- Logout Section -->
        <div class="nav-slide__logout-section">
          <button (click)="logOut()" class="nav-slide__log-out-btn">
            <app-icon-sign-out width="20" height="20" color="#E8EEF2"></app-icon-sign-out>
            <span>Log out</span>
          </button>
        </div>
      </div>
    </div>
